import { useEffect } from 'react';
import { useTimeSpentStore } from "@/src/stores/useTimeSpentStore";

const useAddSessionTimeOnVisibility = () => {
  useEffect(() => {
    const handleBeforeUnload = () => {
      useTimeSpentStore.getState().pauseSession();
    };
    const handleVisibilityChange = () => {
      if (document.visibilityState !== 'visible') {
        // Update session time when the page is hidden
        useTimeSpentStore.getState().pauseSession();
      } else {
        // Update current activity when the page is visible
        useTimeSpentStore.getState().resumeSession();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
};

export default useAddSessionTimeOnVisibility;
